<template>
	<div class="wrapper">
		<b-row>
			<b-col cols="12">
				<b-card header-tag="header">
					<template v-slot:header>
						<i class="icon-pencil"></i> Search by email and RFID
					</template>
					<b-card-body>
						<b-form>
							<b-form-group
								label="Email"
								label-for="Email"
								:label-cols="3"
								:horizontal="true">
								<b-form-input v-model="form.email" name="email" id="email" type="text" placeholder="Email"></b-form-input>
							</b-form-group>
							<b-form-group
								label="RFID"
								label-for="RFID"
								:label-cols="3"
								:horizontal="true">
								<b-form-input v-model="form.rfid" name="rfid" id="rfid" type="text" placeholder="RFID"></b-form-input>
							</b-form-group>
							<b-form-group
							  label="Office"
								label-for="Office"
							  :label-cols="3"
							  :horizontal="true">
								    <multi-select v-model="selectedOffice"
															 :options="officeList"
															 :close-on-select="false"
															 :searchable="true"
															 label = "name"
															 placeholder="Pick a value"></multi-select>
							</b-form-group>
							<b-form-group
								label="Is Admin"
								label-for="isAdmin"
								:label-cols="3"
								:horizontal="true">
								<b-form-checkbox v-model="form.isAdmin" name="isAdmin" id="isAdmin" type="checkbox" ></b-form-checkbox>
							</b-form-group>
							<div class="form-actions">
								<b-button v-on:click="findEmployeesByRfidOrEmail()" variant="primary"><i class="fa fa-dot-circle-o"></i> Search</b-button>
							</div>
						</b-form>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
		<!--<div v-if="hideTable" class="text-center">-->
			<!--<b-spinner label="Loading..." style="width: 4rem; height: 4rem;" variant="info"></b-spinner>-->
		<!--</div>-->
		<div class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<div class="animated fadeIn">
						<genericTable :table-data="employeeList" :fields="fields" :per-page=20 hover striped bordered small
													caption="<i class='icon-list'></i> List of Employees">
							<template v-slot:row-actions="row">
								<b-button v-if="$store.getters.canWrite" size="sm" pill variant="info" class="m-1" @click="resetPassword(row.row.item)">Reset Password</b-button>
							</template>
						</genericTable>
					</div>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
	import customerSupportService from '@/services/customerSupportService'
	import genericTable from "@/components/GenericTable";
	import toastService from "@/services/toastService";
	import officeService from "../../services/officeService";
	import Multiselect from 'vue-multiselect'
	export default {
		name: "PasswordReset",
		components : {
			"genericTable": genericTable,
			"multiSelect" : Multiselect
		},
		data : function ()  {
			return {
				employeeList: [],
				officeList: [],
				selectedOffice:null,
				form :{
					rfid: null,
					email: null,
					isAdmin : false,
				},
				fields: [
					{key: 'id', label: 'ID', sortable: true},
					{key: 'name', label: 'Name', sortable: true, searchable:true},
					{key: 'email', label: 'Email', sortable: true, searchable:true},
					{key: 'rfid', label: 'RFID', sortable: true, searchable:true},
					{key: 'employeeOfficeId', label: 'Employee Office ID', sortable: true, searchable:true},
					{key: 'officeName', label: 'Office', sortable: true, searchable:true},
					{key: 'status', label : 'Status'},
					{key: 'actions', label: 'Actions'}
				]
			}
		},
		methods : {
    	findEmployeesByRfidOrEmail: function() {
    		if(this.form.rfid == null && this.form.email == null && this.selectedOffice == null)
    			toastService.showErrorToast("Please select a filter");
    		const data = Object.assign({},this.form);
    		if(this.selectedOffice != null)
    			data.officeId = this.selectedOffice.id;
				customerSupportService.getEmployeeList(data, (employees) =>{
					console.log(employees);
					this.employeeList = employees;
				})
			},
			resetPassword: function (employee) {
    		customerSupportService.resetPassword(employee.id, r => {
    			toastService.showSuccessToast("Password reset successful");
				}, e => {
    			toastService.showErrorToast("Could not reset password "+ e);
				});

			}
		},
		mounted() {
			officeService.getOfficeList( r => {
				this.officeList = r;
			});
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
